export default "__VITE_ASSET__DMvBAL0k__"